



















import { defineComponent, } from '@vue/composition-api'

export default defineComponent({

  props: {
    dialogMessage: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
})
